import { createApp } from 'vue'
import { isMobile } from '@/model/util/dom/domResponsive'
import * as log from '@/model/util/log/Logger'
import baseconfig from '@/assets/config'
import App from './App.vue'
import router from './router'
import { key, store } from './store'
import { i18n } from './i18n'
import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'focus-visible'

const app = createApp(App)
// focus用のカスタムディレクティブ
app.directive('focus', {
  mounted(el) {
    // DOMにマウントされるとPC版レイアウトの場合のみその要素にフォーカスを当てる
    if (!isMobile()) {
      log.debug(`v-focus focus.`)
      window.setTimeout(() => {
        el.focus()
      }, baseconfig.common.focus.startWait)
    }
  },
})

app
  .use(store, key) // vuex(状態管理)
  .use(router) // router(ルーティング)
  .use(i18n) // i18n(国際化)
  .mount('#app')
